import {
  DOCUMENT_CREATE_FAIL,
  DOCUMENT_CREATE_REQUEST,
  DOCUMENT_CREATE_RESET,
  DOCUMENT_CREATE_SUCCESS,
  DOCUMENT_DELETE_FAIL,
  DOCUMENT_DELETE_REQUEST,
  DOCUMENT_DELETE_RESET,
  DOCUMENT_DELETE_SUCCESS,
  DOCUMENT_LIST_FAIL,
  DOCUMENT_LIST_REQUEST,
  DOCUMENT_LIST_SUCCESS,
} from "../constants/documentConstants";

export const documentListReducer = (state = {}, action) => {
  switch (action.type) {
    case DOCUMENT_LIST_REQUEST:
      return { loading: true };
    case DOCUMENT_LIST_SUCCESS:
      return { loading: false, documents: action.payload, totalDocs: action.total };
    case DOCUMENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const documentCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case DOCUMENT_CREATE_REQUEST:
      return { loading: true };
    case DOCUMENT_CREATE_SUCCESS:
      return { loading: false, success: action.payload };
    case DOCUMENT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case DOCUMENT_CREATE_RESET:
      return { loading: false, error: "", success: "" };
    default:
      return state;
  }
};

export const documentDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case DOCUMENT_DELETE_REQUEST:
        return { loading: true };
      case DOCUMENT_DELETE_SUCCESS:
        return { loading: false, success: action.payload };
      case DOCUMENT_DELETE_FAIL:
        return { loading: false, error: action.payload };
      case DOCUMENT_DELETE_RESET:
        return { loading: false, error: "", success: "" };
      default:
        return state;
    }
  };
